import { EditItem, IEditItem } from "ui/Scripts/source/models/common/editItem";
import { MessageTypeClass } from "ui/Scripts/source/models/enums";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";

export interface IMessageTypeEditItem extends IEditItem {
    code: string;
    name: string;
    image: string;
    defaultImage: string;
    messageTypeClass: MessageTypeClass;
    modifyUser: IModifyUser;
}

export class MessageTypeEditItem extends EditItem implements IMessageTypeEditItem {
    code: string;
    name: string;
    image: string;
    defaultImage: string;
    messageTypeClass: MessageTypeClass;
    modifyUser: IModifyUser;

    constructor();
    constructor(obj: IMessageTypeEditItem);
    constructor(obj?: any) {
        super(obj);
        this.code = obj && obj.code || "";
        this.name = obj && obj.name || "";
        this.image = obj && obj.image || "";
        this.defaultImage = obj && obj.defaultImage || "";
        this.messageTypeClass = obj && obj.messageTypeClass || MessageTypeClass.NormalMessage;
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
}